var map = {
	"./OSINT Engine.png": "f6b6",
	"./OSINT Job Ad.png": "e13e",
	"./OSINT LAB REPORT small.png": "0a19",
	"./OSINT Social Media.png": "4573",
	"./OrgChart.png": "d069",
	"./avatar-si.png": "27fe",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";